module.exports = __webpack_public_path__ + "img/upskilling.ebfa603b.svg";